.vc-std-wrapper {
    display: flex;
    align-items: center;
}

.vc-std-wrapper [class*="communicationDisabled"] {
    margin-right: 0;
}
